import Creditos from "../../components/Creditos";

const CreditosPage = () => <Creditos />;

export default CreditosPage;
